/**
* DevExpress Dashboard (custom-properties-metadata.js)
* Version:  24.1.7
* Build date: Oct 29, 2024
* Copyright (c) 2012 - 2024 Developer Express Inc. ALL RIGHTS RESERVED
* License: https://www.devexpress.com/Support/EULAs/universal.xml
*/
import { validateCustomPropertyName } from './_custom-property-validation';
export function registerCustomProperty(meta) {
    if (_customPropertiesMeta.filter(existingMeta => existingMeta.ownerType === meta.ownerType && existingMeta.propertyName === meta.propertyName)[0]) {
        throw new Error('Duplicated CustomPropertiesMeta');
    }
    validateCustomPropertyName(meta.propertyName);
    _customPropertiesMeta.push(meta);
}
export function _clearCustomPropertiesMeta() {
    _customPropertiesMeta = [];
}
export let _customPropertiesMeta = [];
export function _customMetadataContainsProperty(propertyName) {
    return !!(_customPropertiesMeta.filter(c => c.propertyName === propertyName)[0]);
}
